<template lang="pug">
  app-modal.modalNotificar(
    :titulo="titulo",
    v-if="showModal"
    :width="1000"
    @closeModal="closeModal"
  )
    template(slot="body")
      el-steps.extra-margin-top-bottom(:active='active', finish-status='success', simple)
        el-step(title='Modelo de extrato de sentença')
        el-step(title='Confirmação')
      div(v-if="active === 0")
        app-search-despachos(
          @search="search",
          @input="search",
          @clear="clear",
        )
        div(v-if="modelos.length === 0")
          p.center Ainda não há modelos disponíveis
        div.container-modelo
          div.item(v-for='item in modelos', :key="item.id")
            div(@click='selectModelo(item.id)')
              el-card.cursor-pointer(:class="{ active: item.id === selectedModelo.id }")
                span.descricao {{ item.descricaoTexto }}
                p.border-bottom
                p(v-html="item.textoModelo")
      div(v-if="active === 1", style="padding: 20px;")
        app-label(label="Número do Extrato de sentença:")
        el-input(v-model="numeroExtratoSentenca")
        app-editor-texto.input(
          titulo="Despacho"
          @onTextChange="onTextChange",
          v-model="mensagem",
          ref="editorTexto"
          )
      div(v-if="active === 2")
        app-pdf-viewer(
          v-if="bytes"
          :bytes = "bytes"
        )
    template(slot="footer")
      app-utilizar-buttons(
        @cancel="closeModal",
        @confirm="getFunctionConfirm()",
        :textModel="selectedModelo.textoModelo",
        :textButtonConfirm="getTextoButon()")
</template>

<script>
import { mapActions } from 'vuex'

import AppUtilizarButtons from './AppUtilizarButtons'
import AppSearchDespachos from './AppSearchDespachos'
import AppModal from '@/components/AppModal'
import AppEditorTexto from '../../../components/AppEditorTexto.vue'
import AppPdfViewer from '@/components/AppPDFViewer'
import FileHelper from '@/utils/fileHelper'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {

  components: {
    AppUtilizarButtons,
    AppSearchDespachos,
    AppModal,
    AppEditorTexto,
    AppPdfViewer,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idProcesso: {
      type: Number,
      required: false
    },
    showModal: {
      type: Boolean,
      required: true
    },
    titulo: {
      type: String,
      required: true
    },
    processosSelecionados: {
      type: Array,
      required: false
    }
  },

  data () {
    return {
      selectedModelo: {},
      filtro: { parametro: '', tiposModelo: [8] },
      modelos: [],
      active: 0,
      mensagem: '',
      bytes: null,
      numeroExtratoSentenca: null
    }
  },

  async created () {
    const data = await this.findByFiltroSelecao(this.filtro)
    this.modelos = data
  },

  methods: {
    ...mapActions({
      findByFiltroSelecao: 'modeloDespacho/findByFiltroSelecao',
      getDespachoDinamicoWithData: 'despacho/getDespachoDinamicoWithData',
      getDespachoDinamicoWithText: 'despacho/getDespachoDinamicoWithText',
      criarDespacho: 'despacho/criarDespacho',
      getPdfExtratoSentencaByIdProcessos: 'despacho/getPdfExtratoSentencaByIdProcessos'
    }),

    closeModal () {
      this.numeroExtratoSentenca = null
      this.active = 0
      this.selectedModelo = {}
      this.$emit('closeModal')
    },

    async save () {
      if (this.selectedModelo.textoModelo) {
        this.mensagem = this.selectedModelo.textoModelo
        this.active = 1
      }
    },

    async gerarExtrato () {
      if (!this.numeroExtratoSentenca) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Informe o número do extrato de sentença'
        )
        return
      }
      try {
        // Criar despacho Extrato de sentença para cada processo selecionado
        await Promise.all(
          await this.processosSelecionados.map(async (idProcesso) => {
            await this.criarDespacho({idProcesso: idProcesso, textoDespacho: null})
          })
        )
        // Gera o novo extrato de sentença e seta o id_novo_extrato_sentenca no despacho
        this.bytes = await this.getPdfExtratoSentencaByIdProcessos(
          {
            idsProcessos: this.processosSelecionados,
            texto: this.mensagem,
            numeroExtratoSentenca: this.numeroExtratoSentenca
          })
        this.numeroExtratoSentenca = null
        this.active = 2
      } catch (error) {
        console.log('AppModalSelecionarModeloExtratoSentenca > gerarExtrato: ', error)
      }
    },

    onTextChange (texto) {
      this.mensagem = texto
    },

    async downloadPdf () {
      FileHelper.saveFile(this.bytes, 'EXTRATO_SENTENCA')
    },

    getTextoButon () {
      switch (this.active) {
        case 0:
          return 'Próximo'
        case 1:
          return 'Gerar extrato'
        case 2:
          return 'Download PDF'
      }
    },

    getFunctionConfirm () {
      switch (this.active) {
        case 0:
          this.save()
          break
        case 1:
          this.gerarExtrato()
          break
        case 2:
          this.downloadPdf()
          break
      }
    },

    async search (param) {
      this.filtro.parametro = param
      let data = await this.findByFiltroSelecao(this.filtro)
      this.modelos = data
    },

    clear () {

    },

    selectModelo (id) {
      if (this.selectedModelo.id === id) {
        this.selectedModelo = {}
      } else {
        this.selectedModelo = this.modelos.find(x => x.id === id)
      }
    }
  }
}

</script>

<style scoped lang="scss">
.center {
  text-align: center;
  margin-top: 20px !important;

}
p.message {
  width: 80%;
  margin: 0 auto;
}

.center {
  margin-top: 40px !important;
  text-align: center;
}

.item {
  margin: 5px;
  width: 310px;
}

.el-card {
  max-width: 100%;
  height: 350px;
  font-size: 12px !important;
}

.cursor-pointer {
  cursor: pointer;
}

.container-modelo {
  padding-top: 22px;
  display: flex;
  flex-wrap: wrap;
}
.descricao {
  font-weight: bold;
  font-size: 16px;
}

.border-bottom {
  padding-bottom: 10px;
  border-bottom: solid 1px #A7B2BA;
}

.active {
  background: rgb(223, 223, 223) !important;
}

@media (max-width: 780px) {
  .modalNotificar {
    position: fixed !important;
    width: 395px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppModalSelecionarModeloExtratoSentenca.vue